import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDivider } from '@angular/material/divider';

/**
 * This component is responsible for the display of standardized footer actions
 *
 * @export
 */
@Component({
  selector: 'hypecast-master-admin-dialog-footer',
  templateUrl: './dialog-footer.component.html',
  styleUrls: ['./dialog-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDivider],
})
export class DialogFooterComponent {}
